export type ConversationStartKind =
  | "server"
  | "conversation"
  | "direct"
  | "group"
  | "notes";

/**
 * Select the user-facing beginning-of-conversation composition.
 */
export function getConversationStartKind(
  channelType: string,
  hasServer: boolean,
): ConversationStartKind {
  if (channelType === "SavedMessages") return "notes";
  if (channelType === "DirectMessage") return "direct";
  if (channelType === "Group") return "group";
  if (channelType === "TextChannel" && hasServer) return "server";
  return "conversation";
}
